<template>
  <div class="szw-flex szw-flex-col szw-justify-center szw-items-center szw-h-full szw-text-text-icon-primary">
    <div class="szw-w-36 szw-h-36 szw-rounded-full szw-bg-section-static szw-flex szw-justify-center szw-items-center">
      <sprite sprite-id="service-unavailable" />
    </div>
    <div class="szw-text-base szw-font-bold szw-mt-3">{{ loc('sm_service_unavailable', langId) }}</div>
    <div class="szw-mt-3 szw-text-xs szw-text-center">{{ loc('sm_error_service_unavailable', langId) }}</div>
  </div>
</template>

<script setup>
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import { loc } from '@/__core__/localization/localization'
import { inject } from 'vue'

const langId = inject('langId', '')
</script>
